import React, { Component } from 'react'
import _map from 'lodash.map'
import styled from 'styled-components'

import MetroHeader from '../../styled/metronome'

const BeatOn = styled.div`
  width: ${({ signature }) => 100 / signature}%;
  height: 100%;
  background-color: ${({ theme }) => theme.primary || '#007bff'};
  border: 1px solid ${({ theme }) => theme.borderColor || '#000'};
  float: left;
  cursor: pointer;
`

const BeatOff = styled.div`
  width: ${({ signature }) => 100 / signature}%;
  height: 100%;
  background-color: ${({ theme }) => theme.background || '#ffffff'};
  border: 1px solid ${({ theme }) => theme.borderColor || '#000'};
  float: left;
  cursor: pointer;
`

const getBeats = (signature, onBeat = -1) => {
  const newArr = new Array(signature)
  newArr.fill(false)
  if (onBeat !== -1) {
    newArr[onBeat - 1] = true
  }
  return newArr
}

let tickTock
let unBeatTimeout

class Metronome extends Component {
  constructor (props) {
    super(props)
    this.state = {
      beats: [false, false, false, false],
      bpm: parseInt(this.props.bpm, 10),
      on: false,
      nextBeat: undefined,
      start: undefined,
      signature: parseInt(this.props.signature, 10),
      onBeat: 0,
      rate: 1000 * 60 / parseInt(this.props.bpm, 10), // how many millis between beats
      sound: 'off',
      theme: 'ableton',
      highlightFirst: false
    }
    this.tick = this.tick.bind(this)
    this.handleToggleOn = this.handleToggleOn.bind(this)
    this.unBeat = this.unBeat.bind(this)
    this.changeBpm = this.changeBpm.bind(this)
    this.changeGeneric = this.changeGeneric.bind(this)
    this.scheduledTimeout = null
  }

  componentDidMount () {
    if (this.props.user.settings.metronomeAutoStart && this.props.bpm && this.props.signature) {
      this.handleToggleOn()
    }
  }

  componentWillUnmount () {
    clearInterval(tickTock)
    clearTimeout(unBeatTimeout)
    if (this.scheduledTimeout) {
      clearTimeout(this.scheduledTimeout)
    }
  }

  tick () {
    if (!this.state.on) return

    const nextOnBeat = (this.state.onBeat === this.state.signature) ? 1 : this.state.onBeat + 1
    this.setState({
      on: true,
      onBeat: nextOnBeat,
      beats: getBeats(this.state.signature, nextOnBeat),
      nextBeat: this.state.nextBeat + this.state.rate
    })

    unBeatTimeout = setTimeout(this.unBeat, 250)

    // Schedule next beat with precise timing
    const now = Date.now()
    const drift = now - this.state.nextBeat
    const nextDelay = Math.max(0, this.state.rate - drift)

    this.scheduledTimeout = setTimeout(this.tick, nextDelay)
  }

  unBeat () {
    this.setState({
      beats: getBeats(this.state.signature)
    })
  }

  handleToggleOn () {
    if (!this.state.on) {
      // turning on...set start time...schedule first beat
      const startTime = Date.now()

      this.setState({
        beats: getBeats(this.state.signature, 1),
        onBeat: 1,
        on: true,
        start: startTime,
        nextBeat: startTime + this.state.rate
      })

      unBeatTimeout = setTimeout(this.unBeat, 250)
      this.scheduledTimeout = setTimeout(this.tick, this.state.rate)
    } else {
      // turn off
      if (this.scheduledTimeout) {
        clearTimeout(this.scheduledTimeout)
        this.scheduledTimeout = null
      }
      clearTimeout(unBeatTimeout)
      this.setState({
        on: false,
        start: undefined,
        lastBeatStart: undefined,
        beats: getBeats(this.state.signature)
      })
    }
  }

  changeGeneric (event) {
    this.setState({
      [event.target.name]: event.target.name === 'signature' ? parseInt(event.target.value, 10) : event.target.value
    })

    if (event.target.name === 'theme') {
      tick = new Audio(`${event.target.value}_tick.mp3`) // eslint-disable-line
      tock = new Audio(`${event.target.value}_tock.mp3`) // eslint-disable-line
    }
  }

  changeBpm (event) {
    const num = parseInt(event.target.value, 10)

    if (!isNaN(num)) {
      this.setState({
        bpm: num,
        rate: 1000 * 60 / num
      })
    } else {
      this.setState({
        bpm: event.target.val
      })
    }
  }

  render () {
    const visible = this.props.bpm && this.props.signature && this.props.user.settings.metronomeEnabled
    const bars = _map(this.state.beats, (beat, idx) => beat ? <BeatOn key={`metronome-bar-${idx}`} onClick={this.handleToggleOn} signature={this.state.signature} /> : <BeatOff key={`metronome-bar-${idx}`} onClick={this.handleToggleOn} signature={this.state.signature} />)

    if (visible) {
      return <MetroHeader>{bars}</MetroHeader>
    }
    return null
  }
}

export default Metronome
